export default __webpack_public_path__ + "bca0a60ba083c7d5b5823b2454750a82.ogg";